import * as Yup from "yup";
import { ownerThresholdSchema } from "./schemas";

export type OwnerThresholdProps = {
  thresholdPercentage: number;

  entityName: string;

  initialValues: FormValues | null;

  onContinue: (thresholdMet: boolean) => void;

  onBack: () => void;
};

export type OwnershipThreshold = Yup.InferType<typeof ownerThresholdSchema>;
export type FormValues = {
  ownerThresholdQuestion: "yes" | "no" | "";
};

export const initialValues: FormValues = {
  ownerThresholdQuestion: "",
};
